import { staffClient } from "common/apis/staff";
import EventEditForm from "common/pages/Event/EditForm";
import { FileService } from "common/services/file";
import SpinnerMedium from "components/Spinner/Medium";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

const EventEditorPage = () => {
    const { eventId } = useParams();
    const [eventInfo, setEventInfo] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        console.log("[EventEditPage] useEffect");
        fetchEventInfo();
    }, [])

    const fetchEventInfo = async () => {
        try {
            // const ret = await axios.get(`https://rest.miview.shop/event/${eventId}`);
            const ret = await staffClient.get(`/event/${eventId}`);
            console.log("[EventEditPage] fetchDoctorInfo ret", ret);
            const eventData = ret.data;
            setEventInfo(eventData);
        } catch (e) {
            console.log("[EventEditPage] fetchEventInfo error", e);
        }
    }

    const handleSave = async (formData) => {
        console.log("[EventEditPage] onSave", formData);
        try {
            // const ret = await axios.patch(`https://rest.miview.shop/event/${eventId}`, formData);
            const uploadedMainImage = await FileService.tryUploadFile(formData.mainImage);
            const uploadedCardImage = await FileService.tryUploadFile(formData.cardImage);
            const uploadedDetailImages = await FileService.tryUploadFiles(formData.detailImages);
            const body = {
                ...formData,
                mainImage: uploadedMainImage,
                cardImage: uploadedCardImage,
                detailImages: uploadedDetailImages
            }
            const ret = await staffClient.patch(`/event/${eventId}`, body);
            console.log("[EventEditPage] onSave ret", ret);
            toast.success("이벤트 정보가 수정되었습니다.");
            navigate("/main/event");
        } catch (e) {
            console.log("[EventEditPage] onSave error", e);
            toast.error("이벤트 정보 수정 중 오류가 발생했습니다.");
        }
    }

    if(_.isNil(eventInfo)) {
        return <SpinnerMedium/>
    }
    
    return (
        <div>
            <EventEditForm eventInfo={eventInfo} onSave={handleSave} />
        </div>
    )
}

export default EventEditorPage;
